import styled from "styled-components";
import Container from "react-bootstrap/Container";
import imgHero from "../../assets/hero-web.jpg";
import Row from "react-bootstrap/Row";

export const ContainerHero = styled(Row)`
  /* justify-content: center; */
  a {
    color: #f72952 !important;
  }
  .hero {
    background: #d9d9d9;
    display: flex;
    flex-direction: row;
    background-size: 100% 100%;
    height: 35vh;
    align-items: flex-end;
  }

  .hero-text {
    background: #fff;
    padding: 0;
    margin-top: -110px;
    z-index: 2;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    display: flex;
  }

  .hero-text h1 {
    color: #354052;
    font-size: 24px;
    font-weight: bold;
    line-height: 30px;
    text-transform: uppercase;
    text-align: center;
    padding-top: 30px;
  }

  .hero-text p {
    text-align: left;
    margin-top: 15px;
    font-size: 16px;
    color: #000;
    padding: 0 40px;
  }

  .hero-text .resaltado {
    background-color: #f72d54;
    width: 100%;
  }

  .hero-text .resaltado p {
    color: #fff;
    font-weight: bold;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
  }
`;

